<script>
import constants from '@/constants';
import IconReturn from '@/components/icon/IconReturn.vue';

export default {
    data() {
        return {
            constants: constants,
        };
    },
    components: {
        IconReturn: IconReturn,
    },
};
</script>

<template>
    <router-link
        :to="{ name: constants.ROUTER_NAME.MAIN }"
        class="left_button_main_container"
    >
        <div class="left_button_icon_container">
            <IconReturn icon-height="16px" icon-width="16px" />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Return</label>
        </div>
    </router-link>
</template>
